module.exports = "<app-header></app-header>\n<div class=\"home hidden-xs\"></div>\n<div class=\"home mobile hidden-sm hidden-md hidden-lg hidden-xl\"></div>"


//////////////////
// WEBPACK FOOTER
// /Users/enzo/Desktop/capsycofr-angular/src/app/pages/home/home.component.html
// module id = ../../../../../src/app/pages/home/home.component.html
// module chunks = main